import React, { useEffect, useState } from "react";
import getBrowserFingerprint from 'get-browser-fingerprint';
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Base64 } from 'js-base64';

export default function QuizData({ idTraineData: propIdTraineData = "" ,showHeader}) {
  const { t } = useTranslation(["quizzPage"]);
  const [quizQuestions, setQuizQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [resultsJson, setResultsJson] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const fingerprint = getBrowserFingerprint();

  const finalTitles = t("finaltitles", { returnObjects: true });
  const finalTitlesArray = Array.isArray(finalTitles)
    ? finalTitles
    : (finalTitles ? Object.values(finalTitles) : []);

  const correctLabelObj = finalTitlesArray.find(item => item.fieldType === "correct_label");
  const incorrectLabelObj = finalTitlesArray.find(item => item.fieldType === "incorrect_label");
  const correctAnswerMessageObj = finalTitlesArray.find(item => item.fieldType === "correct_answer_message");
  const nextButtonObj = finalTitlesArray.find(item => item.fieldType === "button" && item.id === "button_final_next");

  const correctLabel = correctLabelObj?.value || "Correct";
  const incorrectLabel = incorrectLabelObj?.value || "Incorrect";
  const correctAnswerMessage = correctAnswerMessageObj?.value || "Correct answer";
  const nextButtonLabel = nextButtonObj?.value || "NEXT";

  const bottomContent = t("bottomContent", { returnObjects: true });
  const bottomContentArray = Array.isArray(bottomContent)
    ? bottomContent
    : (bottomContent ? Object.values(bottomContent) : []);

  const buttonNextObj = bottomContentArray.find(item => item.id === "button_next");
  const buttonPrevObj = bottomContentArray.find(item => item.id === "button_previous");
  const buttonSubmitObj = bottomContentArray.find(item => item.id === "button_submit");

  const buttonNextLabel = buttonNextObj?.value || "Next";
  const buttonPrevLabel = buttonPrevObj?.value || "Previous";
  const buttonSubmitLabel = buttonSubmitObj?.value || "Submit";

  useEffect(() => {
    const fetchQuiz = async () => {
      try {
        let idTraineData = localStorage.getItem("idTraineData")
          ? parseInt(localStorage.getItem("idTraineData"), 10)
          : propIdTraineData;

        if (idTraineData === null) {
          localStorage.setItem("PID", Base64.encode(fingerprint + "P1"));
          return;
        }
        const res = await axios.post(
          process.env.REACT_APP_API_ENDPOINT + "/getquizz",
          { idTraineData }
        );

        if (res.data && Array.isArray(res.data)) {
          setQuizQuestions(res.data); // Assuming API returns quiz questions array
          setCurrentIndex(0);
        } else {
          setErrorMsg("Failed to load quiz questions.");
        }
      } catch (error) {
        setErrorMsg("Error fetching quiz questions.");
        console.error(error);
      }
    };
    fetchQuiz();
  }, [fingerprint, propIdTraineData]);

  const currentQ = quizQuestions[currentIndex] || {};
  const selectedForCurrent = selectedOptions[currentQ.id] ?? null;

  const handleOptionClick = (ans_id) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [currentQ.id]: ans_id,
    }));
    setErrorMsg("");
  };

  const handleNext = () => {
  if (!selectedForCurrent) {
    setErrorMsg(
      currentQ.errorText ||
      buttonNextObj?.errorText ||
      "Please select an answer before proceeding."
    );
    return;
  }
  setErrorMsg("");
  if (currentIndex < quizQuestions.length - 1) {
    setCurrentIndex(currentIndex + 1);
  }
};

const handlePrev = () => {
  setErrorMsg("");
  if (currentIndex > 0) {
    setCurrentIndex(currentIndex - 1);
  }
};

const getMissingRequiredQuestions = () => {
  const missing = [];
  quizQuestions.forEach((q, idx) => {
    if (!selectedOptions[q.id]) {
      missing.push({ id: q.id, idx, title: q.title });
    }
  });
  return missing;
};

const handleSubmit = async () => {
  if (!selectedForCurrent) {
    setErrorMsg(
      currentQ.errorText ||
      buttonSubmitObj?.errorText ||
      "Please select an answer before submitting."
    );
    return;
  }

  const missing = getMissingRequiredQuestions();
  if (missing.length > 0) {
    const firstMissing = missing[0];
    setCurrentIndex(firstMissing.idx);
    setErrorMsg(
      `Please answer all questions. First unanswered: ${firstMissing.title || `Question ${firstMissing.idx + 1}`}`
    );
    return;
  }

  setErrorMsg("");

  const quizzDataArray = quizQuestions.map((q) => ({
    quesId: q.id,
    ansId: selectedOptions[q.id] || null,
  }));

  const idTraineDataStr = localStorage.getItem("idTraineData");
  const idTraineData = idTraineDataStr ? parseInt(idTraineDataStr, 10) : null;

  const payload = {
    idTraineData,
    quizzData: quizzDataArray,
  };

  try {
    const res = await axios.post(
      process.env.REACT_APP_API_ENDPOINT + "/submitquizz",
      payload
    );
    if (res) {
      setResultsJson(res.data);
      setShowResults(true);
      showHeader();
       localStorage.setItem("PID", Base64.encode(fingerprint + "P5"));
    } else {
      alert("There was an error submitting the quiz. Please try again.");
    }
  } catch (err) {
    alert("Failed to submit quiz. Server error.");
    console.error(err);
  }
};


  if (quizQuestions.length === 0) {
    return (
      <div className="container mt-5">
        {errorMsg ? <p className="text-danger">{errorMsg}</p> : <p>Loading quiz...</p>}
      </div>
    );
  }

  const isFirst = currentIndex === 0;
  const isLast = currentIndex === quizQuestions.length - 1;

  return (
    <>
      {showResults && resultsJson ? (
        <div className="mt-3">
          <div className="quiz-submission-summary p-5">
            <h2 className="text-center">{resultsJson?.returnArray?.h1Title}</h2>
    <h4 className="text-center">{resultsJson?.returnArray?.p1Title}</h4>
    <p className="text-center">
      {resultsJson?.returnArray?.p2Title}
    </p>
    <p className="text-center">
      {resultsJson?.returnArray?.p3Title}
    </p>
          </div>

          <div className="result-details mt-4">
            {resultsJson.finalArray.map((item, idx) => (
              <div key={idx} className="mb-3">
                <span className="quiz-question-result">{item.title}: {item.quizzQuestion}</span>
                {item.status === "correct" ? (
                  <span className="float-end quiz-answer-status" style={{ color: "#562274" }}>{correctLabel}</span>
                ) : (
                  <>
                    <span className="float-end quiz-answer-status" style={{ color: "red" }}>{incorrectLabel}</span>
                    <br />
                    <span className="quiz-correct-answer">{correctAnswerMessage}: {item.correctAnswer}</span>
                  </>
                )}
              </div>
            ))}
          </div>

          <div className="mt-4 float-end">
            <button className="btn-quiz-next" onClick={() => {
              // setShowResults(false);
              // setSelectedOptions({});
              // setCurrentIndex(0);
             localStorage.setItem("PID", Base64.encode(fingerprint + "P5"));
          window.location.reload();
            }}>
              {nextButtonLabel}
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-3">
          <h5 className="mb-4">
            {currentQ.topsection}
          </h5>
          <h6 className="mb-4">
            {currentQ.title}. {currentQ.description}
          </h6>

          <div className="list-group quiz-options-list">
            {currentQ.values?.map((opt, index) => {
              const isActive = selectedForCurrent === opt.ans_id;
              return (
                <button
                  key={opt.ans_id}
                  className={`quiz-options${isActive ? " active text-white" : ""}`}
                  onClick={() => handleOptionClick(opt.ans_id)}
                >
                  {String.fromCharCode(65 + index)}) {opt.description}
                </button>
              );
            })}
          </div>
          {errorMsg && (
            <p className="text-danger mb-0 quiz-error-msg">
              {errorMsg}
            </p>
          )}

          <div className="justify-content-between float-end">
            {!isFirst && (
              <button onClick={handlePrev} className="btn-quiz-previous">
                {buttonPrevLabel}
              </button>
            )}
            {isLast ? (
              <button onClick={handleSubmit} className="btn-quiz-next">
                {buttonSubmitLabel}
              </button>
            ) : (
              <button onClick={handleNext} className="btn-quiz-next">
                {buttonNextLabel}
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
}
